/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2021-07-20 17:13:47
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\utils\auth.js
 */
//token信息
export function getToken() {
    return sessionStorage.getItem('token');
}

export function setToken(token) {
    return sessionStorage.setItem('token', token);
}
export function getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
    })
}


// WEBPACK FOOTER //
// ./src/utils/auth.js